import { render, staticRenderFns } from "./lapHarian.vue?vue&type=template&id=2d063218&"
import script from "./lapHarian.vue?vue&type=script&lang=js&"
export * from "./lapHarian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QFile,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QFile,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
